(function($) {
    var documentLoad = function() {
        $('.announcement-bar').each(function() {
            var announcementBar = this;
            var options = {
                appendArrows: $(announcementBar).find('.action-wrapper'),
                nextArrow: $(announcementBar).find('.action-wrapper .next-arrow'),
                prevArrow: $(announcementBar).find('.action-wrapper .prev-arrow'),
                autoplay: true,
                autoplaySpeed: $(announcementBar).data('interval'),
            };
            var slickSlider = $(announcementBar).find('.announcement-slider');
            $(slickSlider).on('init' , function() {
                $(announcementBar).removeClass('loading');
            });
            $(slickSlider).slick(options);

            $(announcementBar).find('.action-wrapper .pause-button').on('click', function() {
                $(slickSlider).slick('slickPause');
                $(announcementBar).toggleClass('slider-paused');
            });
            $(announcementBar).find('.action-wrapper .play-button').on('click', function() {
                $(slickSlider).slick('slickPlay');
                $(announcementBar).toggleClass('slider-paused');
            });
        });
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/announcement-bar.js